import HmEventRegistry from './../model/HmEventRegistry';
import UrlManager from './../model/UrlManager';
import NativeAjax from './../util/NativeAjax';
import HmAjax from './../util/HmAjax';
import UserStorageUtil from './../util/UserStorageUtil';

const LumosHeartBeat = function(){
	
	const LUMOS_HEARTBEAT_URL = UrlManager.getUrlForAction("LUMOS_SESSION_CHECK");

	const PLP_LOGOUT_URL = UrlManager.getUrlForAction("LOGOUT");

	const FAIL_MAX_COUNT  = (window.lumos && window.lumos.FAIL_MAX_COUNT && !isNaN(window.lumos.FAIL_MAX_COUNT) && window.lumos.FAIL_MAX_COUNT > 0) ? window.lumos.FAIL_MAX_COUNT : 0;

	const BEAT_INTERVAL = (window.lumos && window.lumos.BEAT_INTERVAL && !isNaN(window.lumos.BEAT_INTERVAL) && window.lumos.BEAT_INTERVAL > 0) ? window.lumos.BEAT_INTERVAL : 30;

	let failCount = 0;

	let scheduler = null;

	let failureHandler = () => {
		failCount ++;	

		if(failCount >= FAIL_MAX_COUNT){
			if(scheduler){
				try{
					clearInterval(scheduler);
				}catch(e){}				
			}
			new HmAjax(PLP_LOGOUT_URL).get();
		}
	}

	let isActive = false;

	return {
		initiate:function(){
			let success = (userObj) => {
				if(typeof userObj === "object" && userObj.sessionValid){
					failCount = 0;
				}else{
					failureHandler();
				}
			}

			let failure = (err) => {
				failureHandler();
			}

			
			new NativeAjax(LUMOS_HEARTBEAT_URL).enableCORS().get(success, failure);
		},
		schedule:function(){
			let me = this;
			let userObj = UserStorageUtil.getStoredSessionItem("USER_DETAILS");
			let authProviderId = (userObj && userObj.authProviderId) ? userObj.authProviderId : 0;
			
			if(authProviderId === 5){
				if(!isActive){
					scheduler =	setInterval(() => {
						me.initiate();
					}, BEAT_INTERVAL * 1000);	

					isActive = true;
				}
			}
		}
	}
}();

export default LumosHeartBeat;


HmEventRegistry.registerEvent("SCHEDULE_LUMOS_HEARTBEAT",function(){
	try{
		LumosHeartBeat.schedule();
	}catch(e){}	
});


// WEBPACK FOOTER //
// ./src/vendors/LumosHeartBeat.js